"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.appReducer = void 0;
function appReducer(state, action) {
    if (state === void 0) { state = { count: 1 }; }
    switch (action.type) {
        case 'SELECT_STORE': {
            var selectedStoreState = action.payload;
            return __assign(__assign({}, state), { selectedStore: selectedStoreState });
        }
        case 'DEVICE_INVENTORY': {
            var deviceInventory = action.payload;
            return __assign(__assign({}, state), { deviceInventory: deviceInventory });
        }
        case 'STORE_LIST_UPDATE': {
            var storeList = action.payload;
            return __assign(__assign({}, state), { storeList: storeList });
        }
        case 'SELECTED_RADIUS': {
            var selectedRadius = action.payload;
            return __assign(__assign({}, state), { selectedRadius: selectedRadius });
        }
        case 'ZIP_CODE': {
            var zipCode = action.payload;
            return __assign(__assign({}, state), { zipCode: zipCode });
        }
        case 'ADDRESS_AVAIL': {
            var addressAvail = action.payload;
            return __assign(__assign({}, state), { addressAvail: addressAvail });
        }
        case 'CLEAR_STORE': {
            return __assign(__assign({}, state), { selectedStore: null });
        }
        default: return state;
    }
}
exports.appReducer = appReducer;
//# sourceMappingURL=C2SReducer.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/C2S/C2SReducer.js
// module id = 2214
// module chunks = 8